var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 573,
    height: 443,
    viewBox: "0 0 573 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.871 382.239C361.358 382.239 446.871 296.725 446.871 191.239C446.871 85.7524 361.358 0.23877 255.871 0.23877C150.385 0.23877 64.8711 85.7524 64.8711 191.239C64.8711 296.725 150.385 382.239 255.871 382.239Z",
    fill: "#D2FFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480.124 200.807C515.501 200.807 544.18 172.128 544.18 136.751C544.18 101.374 515.501 72.6953 480.124 72.6953C444.747 72.6953 416.068 101.374 416.068 136.751C416.068 172.128 444.747 200.807 480.124 200.807Z",
    fill: "#E3FFD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.064 129.75H324.829C324.829 129.75 325.879 120.766 316.195 116.682C306.511 112.482 297.294 127.067 297.294 127.067C297.294 127.067 289.126 85.0629 248.056 78.6457C206.986 72.2284 197.885 125.783 197.885 125.783C197.885 125.783 196.251 118.666 191.818 119.249C187.384 119.833 185.05 127.767 185.05 127.767C185.05 127.767 167.666 112.482 155.064 129.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.825 129.75H77.7051C77.7051 129.75 101.04 115.165 112.825 129.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.541 49.9431L445.473 50.8765C445.473 50.8765 441.623 38.6255 423.071 48.193C423.071 48.193 417.354 17.2736 388.768 16.5735C360.299 15.8735 352.482 47.9596 352.482 47.9596C352.482 47.9596 343.848 40.609 335.214 41.0757C326.58 41.5424 325.063 48.193 325.063 48.193C325.063 48.193 312.695 22.0574 295.427 20.3072C278.159 18.5571 267.541 49.9431 267.541 49.9431Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.516 61.0276L369.749 238.493L410.353 245.727L434.855 100.931L369.516 61.0276Z",
    fill: "url(#paint0_linear_841_877)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.458 410.008L447.34 108.982L413.387 131.034L331.013 200.457L327.746 221.225L468.458 410.008Z",
    fill: "url(#paint1_linear_841_877)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.899 442.794L573 393.323H0L4.78376 434.043L563.899 442.794Z",
    fill: "url(#paint2_linear_841_877)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573 393.323L507.544 372.321L69.3061 368.004L0 393.323H573Z",
    fill: "url(#paint3_linear_841_877)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.546 372.322L508.129 343.036H65.1074L69.3078 368.004L507.546 372.322Z",
    fill: "url(#paint4_linear_841_877)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1074 343.036L108.628 331.251H470.676L508.129 343.036H65.1074Z",
    fill: "url(#paint5_linear_841_877)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.509 331.251L106.176 312.233L470.908 313.75L470.674 331.251H108.509Z",
    fill: "url(#paint6_linear_841_877)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.176 312.233L134.878 309.199L442.555 308.149L470.908 313.75L106.176 312.233Z",
    fill: "url(#paint7_linear_841_877)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.554 308.149V292.631L131.377 293.214L132.894 309.199L442.554 308.149Z",
    fill: "url(#paint8_linear_841_877)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.037 291.814V280.73L150.746 279.213L151.096 291.814H427.037Z",
    fill: "url(#paint9_linear_841_877)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.037 280.73L410.819 279.213L164.864 278.163L150.746 279.213L427.037 280.73Z",
    fill: "url(#paint10_linear_841_877)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.818 279.213V267.429L164.514 268.712L164.864 278.163L410.818 279.213Z",
    fill: "url(#paint11_linear_841_877)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.401 269.413V257.628L178.398 258.328L178.865 270.929L397.401 269.413Z",
    fill: "url(#paint12_linear_841_877)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.885 250.744L389.702 260.545H190.068L189.951 249.461L388.885 250.744Z",
    fill: "url(#paint13_linear_841_877)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.984 242.227L377.217 252.728L199.635 254.128L199.285 242.227H376.984Z",
    fill: "url(#paint14_linear_841_877)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.933 236.159L369.517 245.027L208.619 245.727V235.109L368.933 236.159Z",
    fill: "url(#paint15_linear_841_877)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.35 230.326L361.816 237.326L216.32 235.109V229.392L361.35 230.326Z",
    fill: "url(#paint16_linear_841_877)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.514 268.713L178.748 267.312L397.401 265.912L410.818 267.429L164.514 268.713Z",
    fill: "url(#paint17_linear_841_877)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.736 223.792L417.819 100.581L369.515 61.0276L376.399 61.4943L447.339 108.982L345.48 216.441V221.225L345.363 225.542L334.629 227.876L229.736 223.792Z",
    fill: "url(#paint18_linear_841_877)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.179 231.259V223.792H223.668V231.259H353.179Z",
    fill: "url(#paint19_linear_841_877)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.554 292.631L427.036 290.764L148.178 291.814L131.377 293.214L442.554 292.631Z",
    fill: "url(#paint20_linear_841_877)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.315 311.766L192.166 310.949H220.635L208.034 312.699L207.8 331.251L166.963 343.035L167.897 369.171L119.359 393.323V434.51H21.584L24.3842 393.323L123.326 368.704L125.543 343.035L179.564 331.251L181.315 311.766Z",
    fill: "#097A57"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M212.934 264.862C212.934 264.862 206.983 268.829 205.933 269.995C204.883 271.046 202.083 276.296 201.85 276.763C202.2 275.246 213.634 226.358 212.817 223.558C212 220.641 199.633 222.275 194.032 229.742C194.966 225.658 203.833 212.007 203.833 212.007C198.349 212.59 172.914 218.074 172.914 218.074C167.43 219.474 151.679 226.708 151.679 226.708C149.578 241.293 137.444 277.696 132.427 292.397C130.677 293.681 128.46 295.548 127.176 297.181C124.96 300.098 117.142 341.635 118.776 353.769C118.776 353.769 116.209 354.236 114.692 355.17C113.992 355.636 113.058 356.686 112.125 357.853C114.109 345.952 119.476 313.166 119.359 301.265C119.359 301.265 112.242 294.264 102.324 299.398C103.141 297.765 108.041 293.098 111.308 286.564C114.575 280.03 122.859 227.175 122.859 227.175L121.343 223.675L124.376 206.407L168.363 190.189C169.88 189.722 171.397 189.372 173.147 189.138L166.963 196.606C166.963 196.606 164.863 199.989 182.131 199.756C199.516 199.523 223.551 197.656 223.551 197.656C223.551 197.656 205.817 251.444 212.934 264.862Z",
    fill: "url(#paint21_linear_841_877)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.086 281.547L201.503 283.53L201.386 283.763C201.386 283.763 201.619 288.664 199.519 290.997C198.936 291.698 198.119 292.164 197.069 292.281C197.069 292.281 196.836 291.931 196.602 291.347C195.669 289.597 193.685 286.097 192.752 285.747C191.469 285.28 187.735 285.28 187.735 285.28C187.735 285.28 186.918 283.88 187.035 283.297C187.152 282.713 188.202 282.247 188.202 282.247L189.368 278.396L189.952 276.53L201.036 273.846C201.036 273.846 200.919 274.546 200.919 275.596C200.803 276.763 200.803 278.163 200.803 279.446C200.803 280.38 200.919 281.08 201.036 281.43H202.086V281.547Z",
    fill: "#2D5912"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M201.503 283.53L201.386 283.764C201.386 283.764 201.619 288.664 199.519 290.998L196.602 291.348C195.669 289.597 193.685 286.097 192.752 285.747C191.469 285.28 187.735 285.28 187.735 285.28C187.735 285.28 186.918 283.88 187.035 283.297C187.152 282.713 188.202 282.247 188.202 282.247L189.368 278.396L195.786 275.83L200.803 275.596C200.686 276.763 200.686 278.163 200.686 279.447C200.686 279.447 199.053 282.247 191.585 282.363L189.952 283.064C190.068 283.18 199.286 285.047 201.503 283.53Z",
    fill: "#1CA379"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.153 371.962C113.753 373.712 101.852 369.862 101.852 369.862L101.502 362.978L113.753 352.594L113.52 357.844C113.52 357.844 114.92 357.844 115.036 358.311C115.153 358.777 113.87 361.228 113.87 361.228C113.87 361.228 116.553 370.095 115.153 371.962Z",
    fill: "#2D5912"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M115.153 371.962C113.753 373.712 101.852 369.862 101.852 369.862L101.502 362.978L113.753 352.594L113.52 357.844C113.52 357.844 110.836 363.094 105.236 366.361C105.702 366.128 113.986 362.278 115.036 358.311C115.153 358.777 113.87 361.228 113.87 361.228C113.87 361.228 116.553 370.095 115.153 371.962Z",
    fill: "#1CA379"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.886 148.885C211.886 148.885 212.469 149.702 212.119 150.169C212.003 150.402 210.252 150.752 207.919 151.219C207.802 151.219 207.686 151.219 207.452 151.335C207.336 151.335 207.219 151.335 207.102 151.452H206.986C205.352 151.802 203.369 152.385 201.268 152.969C195.668 154.836 190.651 158.919 190.651 158.919L191.818 159.386C191.818 159.386 195.785 158.803 197.068 158.219C198.351 157.636 200.218 156.352 200.218 156.352C200.218 156.352 204.302 155.886 206.052 157.986L205.469 159.503C205.469 159.503 201.152 159.153 196.951 161.02C192.751 162.886 189.717 164.286 188.784 164.52C188.667 164.52 188.551 164.52 188.434 164.52C188.201 164.52 187.967 164.403 187.734 164.286C187.617 164.17 187.5 164.17 187.267 164.053C185.984 163.47 184.234 162.42 182.95 161.836C182.717 161.72 182.6 161.603 182.367 161.603C182.367 161.603 182.25 161.603 182.25 161.486C182.133 161.486 182.017 161.37 181.9 161.37C181.783 161.37 181.667 161.253 181.667 161.253C181.55 161.253 181.55 161.253 181.433 161.253C181.083 161.253 180.266 161.486 179.216 161.836C178.166 162.186 176.883 162.653 175.949 163.003C175.249 163.236 174.666 163.47 174.666 163.47L176.766 153.902C176.766 153.902 177.116 153.786 177.583 153.669C177.7 153.669 177.933 153.552 178.05 153.552C178.166 153.552 178.4 153.436 178.516 153.436C179.683 153.086 181.2 152.502 182.017 152.152C183.533 151.569 191.818 142.701 193.801 141.885C195.785 141.068 200.802 140.718 200.802 140.718C200.802 140.718 200.918 141.535 200.568 142.001C200.335 142.235 198.118 143.168 196.485 143.868C195.551 144.335 194.734 144.685 194.501 144.801C193.918 145.268 192.751 146.668 192.634 146.902C192.868 146.785 196.018 144.918 199.051 144.218C199.285 144.218 199.518 144.101 199.752 144.101C203.018 143.518 210.136 144.685 210.136 144.685C210.136 144.685 210.486 146.202 209.902 146.668C209.902 146.668 212.119 147.018 212.586 147.485C213.053 147.252 212.703 148.535 211.886 148.885Z",
    fill: "url(#paint22_linear_841_877)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M210.136 145.385C210.136 145.385 205.002 145.035 201.735 145.385C198.585 145.735 194.734 147.485 194.734 147.485C194.734 147.485 202.435 144.568 209.786 146.085C209.786 146.085 210.136 145.735 210.136 145.385Z",
    fill: "url(#paint23_linear_841_877)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M211.885 148.885C211.885 148.885 207.802 147.835 203.485 148.069C199.051 148.302 196.834 149.702 196.834 149.702C196.834 149.702 202.084 148.535 205.235 148.535C208.502 148.535 211.885 148.885 211.885 148.885Z",
    fill: "url(#paint24_linear_841_877)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.582 152.152L180.149 151.919C180.149 151.919 181.783 159.153 178.399 164.053L175.016 165.337C175.016 165.22 178.166 154.953 177.582 152.152Z",
    fill: "url(#paint25_linear_841_877)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.882 151.802L178.399 152.035C178.399 152.035 178.399 162.886 174.549 167.437L166.965 167.903C166.965 167.903 169.298 156.119 169.882 151.802Z",
    fill: "#005138"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.412 307.673L200.445 307.323L198.111 307.206C198.111 307.206 198.345 306.623 198.811 306.039C199.511 304.873 200.795 303.123 201.845 303.123C202.662 303.123 203.362 304.289 203.828 305.456C204.062 306.506 204.412 307.673 204.412 307.673Z",
    fill: "#B53D27"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.18 296.938C225.063 297.172 224.947 297.405 224.83 297.639C219.93 308.139 204.295 307.556 204.295 307.556C204.295 307.556 202.661 305.456 201.961 305.573C201.495 305.573 200.795 306.506 200.211 307.323C199.861 307.906 199.511 308.373 199.511 308.373C194.494 310.356 185.16 308.373 185.16 308.373L184.227 304.872L198.578 299.272L205.462 298.689L225.18 296.938Z",
    fill: "url(#paint26_linear_841_877)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.32 389.463L118.303 389.23L116.203 389.113C116.203 389.113 116.203 388.763 116.32 388.18C116.553 386.78 117.37 384.096 119.587 384.913C121.22 385.496 122.154 386.78 122.737 387.83C123.204 388.763 123.32 389.463 123.32 389.463Z",
    fill: "#B53D27"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.956 376.629C137.322 388.063 123.321 389.463 123.321 389.463C120.988 387.83 119.354 388.063 119.354 388.063L118.304 389.23L116.087 391.797C110.604 394.947 100.803 392.38 100.803 392.38L100.336 389.347V388.88L103.253 383.863L122.971 379.896L138.956 376.629Z",
    fill: "url(#paint27_linear_841_877)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.069 200.456C224.485 205.007 222.035 213.291 219.585 224.025C216.318 238.026 213.168 263.228 213.051 264.745V264.862C213.051 264.862 207.101 268.829 206.05 269.996C205 271.046 202.2 276.296 201.967 276.763C197.066 282.013 188.199 279.68 188.199 279.68L188.549 278.28C191.933 270.696 193.216 233.709 194.149 229.625C195.083 225.542 203.95 211.891 203.95 211.891C198.467 212.474 173.031 217.958 173.031 217.958C167.547 219.358 151.796 226.592 151.796 226.592C149.929 239.543 140.245 269.412 134.528 286.33C133.828 288.547 133.127 290.531 132.544 292.164C132.544 292.164 132.544 292.164 132.544 292.281C131.261 296.131 130.444 298.348 130.444 298.348C125.427 312.233 119.593 349.686 119.01 353.186C119.01 353.303 119.01 353.303 119.01 353.42C119.01 353.42 116.443 353.886 114.926 354.82C114.226 355.286 113.292 356.336 112.359 357.503C111.309 358.903 110.375 360.42 110.375 360.42C106.992 363.454 101.041 363.104 101.041 363.104L100.691 361.004C97.191 334.635 101.741 300.682 102.558 299.048C103.258 297.531 107.575 293.448 110.726 287.614C110.959 287.147 111.309 286.68 111.542 286.097C114.809 279.563 123.093 226.708 123.093 226.708L121.576 223.208L124.61 205.94L168.597 189.722C170.114 189.255 171.631 188.905 173.381 188.672C173.731 188.672 173.964 188.555 174.314 188.555C174.314 188.555 174.314 188.555 174.431 188.555C191.466 186.222 216.201 192.405 223.319 195.672C224.485 196.139 225.069 196.606 225.186 196.956C225.302 197.656 225.302 198.823 225.069 200.456Z",
    fill: "#2D5912"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.957 376.629C137.557 385.496 124.256 388.647 124.256 388.647C124.256 388.647 123.672 388.297 122.855 387.946C121.689 387.363 119.938 386.78 119.238 387.013C118.538 387.246 117.372 387.713 116.438 388.297C115.388 388.88 114.571 389.347 114.571 389.347C107.687 391.213 100.453 389.347 100.453 389.347C100.453 389.347 99.6367 387.48 99.8701 386.08C99.9867 384.68 101.97 369.978 101.97 369.978C101.97 369.978 109.088 369.862 111.421 367.995C111.888 367.528 114.105 371.378 114.455 370.795C115.621 368.928 114.105 362.278 114.105 362.278C114.105 362.278 120.405 369.978 124.489 373.129C125.306 373.712 126.006 374.179 126.589 374.412C130.089 375.579 134.406 374.179 134.406 374.179C137.44 374.062 138.957 376.629 138.957 376.629Z",
    fill: "#1CA379"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.188 296.948C225.188 296.948 225.071 297.182 224.838 297.648C224.254 298.932 222.504 301.499 218.654 303.482C213.52 306.166 204.069 305.699 204.069 305.699C204.069 305.699 203.953 305.582 203.719 305.466C203.136 305.116 202.202 304.532 202.086 304.532C201.852 304.649 199.636 305.816 199.636 305.816C199.285 305.932 198.935 305.932 198.585 305.932C191.935 306.866 184.468 304.766 184.468 304.766C183.417 298.348 187.851 285.397 187.851 285.397C187.851 285.397 193.335 283.88 195.552 284.697C197.769 285.514 198.935 288.897 200.102 288.897C201.036 288.897 201.386 283.764 201.386 283.764C201.386 283.764 204.419 288.197 207.57 290.998C208.736 292.048 209.903 292.864 210.953 293.215C215.037 294.615 221.454 294.615 221.454 294.615C224.488 294.965 225.188 296.948 225.188 296.948Z",
    fill: "#1CA379"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.917 73.0449C179.917 73.0449 180.851 75.8452 181.317 76.7786C181.901 77.8287 182.134 78.1787 182.134 78.5287C182.134 78.7621 181.784 80.2789 180.267 80.6289C178.867 81.0956 179.917 73.0449 179.917 73.0449Z",
    fill: "#D2726C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.433 66.978C181.433 66.978 179.799 70.945 179.916 72.4618C180.033 73.8619 180.733 76.0788 180.733 76.7788C180.733 80.1625 179.216 88.5632 174.665 93.4636C174.432 93.697 174.199 93.9303 173.965 94.2804C173.965 94.2804 169.415 93.697 165.215 91.2468V93.1136C165.215 93.1136 162.414 93.1136 158.681 93.3469C154.014 93.697 147.83 94.397 143.746 96.2639C143.863 96.1472 144.796 94.5137 145.73 92.2969C146.663 90.3133 147.596 87.8631 148.18 85.2962C148.297 84.5962 148.413 83.8961 148.53 83.0794C148.647 82.2626 148.647 81.4459 148.647 80.6292C148.53 78.179 147.946 76.4288 147.246 74.562C145.963 71.0617 144.096 67.4447 143.746 59.9774C143.746 59.9774 151.447 47.7263 160.431 44.576C169.415 41.4257 180.966 55.6603 180.966 55.6603C180.966 55.6603 182.133 61.0274 181.433 66.978Z",
    fill: "url(#paint28_linear_841_877)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.55 61.4943C181.55 61.4943 181.55 58.344 180.85 55.3104C180.85 55.3104 179.216 61.4943 177.933 66.3947C176.65 71.4118 176.416 75.6122 176.416 75.6122L175.716 76.0789C175.716 76.0789 176.65 67.6781 175.133 66.5114C173.616 65.3446 167.549 68.6116 168.366 77.7124C168.366 77.7124 158.448 83.1962 148.064 82.9628C148.064 82.9628 148.414 81.446 147.947 79.2291C147.014 74.7954 141.53 66.8614 142.113 53.0935L139.43 51.11C139.78 51.2267 142.93 52.2768 149.931 48.6598C157.281 44.8095 168.132 39.6757 169.649 39.909C171.166 40.1424 176.416 44.8095 176.416 44.8095C176.416 44.8095 183.067 48.7765 184.35 50.2933C185.4 51.9268 181.55 61.4943 181.55 61.4943Z",
    fill: "url(#paint29_linear_841_877)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M180.031 58.5774C180.031 58.5774 177.231 61.961 170.347 62.8944C170.347 62.8944 166.497 65.228 165.797 68.7283C165.797 68.7283 168.014 65.1113 171.164 64.6446C174.198 64.1779 177.815 64.5279 178.748 63.7112L180.031 58.5774Z",
    fill: "url(#paint30_linear_841_877)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M180.733 56.127C180.733 56.127 176.766 60.2106 172.916 61.4941C172.916 61.4941 177.7 60.3273 180.033 58.5772L180.733 56.127Z",
    fill: "url(#paint31_linear_841_877)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M168.715 43.526C168.715 43.526 178.516 42.9427 184.116 50.41C184.116 50.41 184.583 52.5102 183.299 53.9103C183.416 53.9103 178.632 47.3764 168.715 43.526Z",
    fill: "url(#paint32_linear_841_877)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M157.865 45.1596C157.865 45.1596 168.366 42.7094 169.416 39.9091C169.533 39.9091 167.316 39.5591 157.865 45.1596Z",
    fill: "url(#paint33_linear_841_877)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M167.547 53.5602C167.547 53.5602 165.331 56.8272 163.23 57.5272C163.23 57.5272 175.715 56.2438 178.165 50.0599C178.165 50.0599 176.182 47.6097 172.915 48.1931C169.648 48.8931 167.547 53.5602 167.547 53.5602Z",
    fill: "url(#paint34_linear_841_877)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M139.312 51.2266C139.312 51.2266 142.113 54.7269 147.597 54.3769L154.247 46.5595C154.247 46.4428 144.096 52.51 139.312 51.2266Z",
    fill: "url(#paint35_linear_841_877)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.326 205.823C109.326 205.823 119.594 205.59 128.461 203.256C137.329 200.923 131.378 189.372 131.378 189.372L125.194 188.322L109.326 205.823Z",
    fill: "#097A57"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.167 122.633C181.2 133.484 176.3 141.885 176.3 141.885C172.333 148.652 168.483 170.937 169.066 172.687C169.533 174.087 171.75 175.954 172.683 177.238L172.8 177.354C173.033 177.588 173.15 177.938 173.15 178.054C173.383 179.221 170.583 182.605 170.699 183.305C170.699 183.538 171.4 184.588 172.1 185.872C172.566 186.688 173.15 187.622 173.616 188.322C174.2 189.139 174.55 189.722 174.55 189.722L168.366 189.955C153.898 206.757 122.045 206.29 122.045 206.29L122.862 196.723C118.312 201.506 108.277 206.29 108.277 206.29C108.277 206.29 124.262 173.504 124.029 152.619C124.029 152.385 124.029 152.152 124.029 152.152C124.029 150.752 123.912 149.469 123.795 148.302C120.995 127.883 121.929 108.632 122.629 107.932C123.212 107.348 123.329 107.465 128.229 105.481C129.046 105.131 130.096 104.665 131.146 104.081L131.379 103.965C136.163 101.281 141.88 96.9639 141.88 96.9639V93.2302C152.148 86.813 165.216 91.1301 165.216 91.1301C177.817 90.8967 189.368 93.9303 189.368 93.9303C191.001 102.798 188.434 113.532 185.167 122.633Z",
    fill: "#005138"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M122.976 196.722L122.742 196.606C128.459 185.405 130.093 167.087 131.726 149.352C132.543 140.134 133.36 131.383 134.643 124.266C138.494 103.964 146.544 94.9802 146.661 94.9802L146.894 95.2136C146.778 95.3303 138.844 104.198 134.993 124.383C133.593 131.5 132.893 140.251 132.076 149.468C130.443 167.203 128.809 185.521 122.976 196.722Z",
    fill: "url(#paint36_linear_841_877)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.766 235.693C176.766 235.693 177.816 249.461 174.316 258.912L169.299 259.262C169.299 259.262 164.282 278.047 157.631 286.214C157.631 286.214 127.645 283.997 103.143 277.23L95.209 270.813C95.209 270.813 102.676 236.976 109.794 220.292C109.91 220.292 145.263 232.543 176.766 235.693Z",
    fill: "url(#paint37_linear_841_877)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.908 220.292C109.908 220.292 141.994 231.026 162.879 231.259C162.879 231.259 167.78 232.893 176.881 235.693C176.881 235.693 147.595 233.476 121.459 224.492L109.908 220.292Z",
    fill: "url(#paint38_linear_841_877)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.598 220.408C154.598 220.408 157.981 223.091 155.764 231.842C155.764 231.842 157.515 232.892 160.198 232.192C160.198 232.192 160.315 222.508 159.265 218.891L154.598 220.408Z",
    fill: "#50182A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.143 277.23C103.143 277.23 115.16 246.66 119.127 225.542L121.461 227.175C121.461 227.175 122.744 240.71 121.227 249.46L122.978 250.861C122.978 250.861 124.611 231.959 121.227 224.492L109.676 220.408C109.676 220.408 103.609 233.126 95.0918 270.929L103.143 277.23Z",
    fill: "#4B1124"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.279 225.775C129.279 225.775 129.863 226.825 134.763 227.642C134.763 227.642 138.847 220.291 141.88 218.541V211.424C141.88 211.541 133.363 218.191 129.279 225.775Z",
    fill: "#50182A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.247 252.261L153.081 253.544C153.081 253.544 153.431 257.628 151.331 261.478L145.73 260.428V258.795L146.781 252.611L147.247 252.261Z",
    fill: "#2D5912"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.247 252.261C147.247 252.261 148.297 256.694 145.73 260.545V258.911L146.781 252.727L147.247 252.261Z",
    fill: "#755689"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.48 273.379C140.48 273.379 141.997 271.863 143.631 267.896L147.598 269.062C147.598 269.062 147.248 272.096 144.914 274.196L140.48 273.379Z",
    fill: "#2D5912"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.63 267.896H141.529L139.779 273.029L140.363 273.379C140.479 273.379 143.28 270.462 143.63 267.896Z",
    fill: "#755689"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M172.68 131.034C172.097 131.5 171.397 131.85 170.58 132.2C171.747 131.5 172.447 131.15 172.68 131.034Z",
    fill: "url(#paint39_linear_841_877)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M203.836 211.891L217.604 205.823C217.604 205.823 214.454 218.425 212.82 220.408C211.187 222.392 198.936 218.891 194.035 229.742C194.035 229.626 197.652 221.342 203.836 211.891Z",
    fill: "#5A9D2F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.196 217.258L158.446 220.408L157.979 221.225L154.479 220.875L153.312 220.291L146.895 220.058L145.961 220.875L141.761 220.525L140.594 219.241L141.761 218.541V211.424L140.244 207.69C140.244 207.69 140.477 206.64 142.578 201.623L146.311 200.34L157.046 202.206C157.162 202.44 160.313 210.841 160.196 217.258Z",
    fill: "url(#paint40_linear_841_877)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.879 201.623V202.673C141.879 202.673 150.28 204.073 157.63 202.44L157.397 200.106C157.514 200.106 149.813 201.74 141.879 201.623Z",
    fill: "url(#paint41_linear_841_877)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.799 117.849C186.799 117.849 173.848 130.8 166.264 147.952C165.798 149.002 165.331 150.052 164.981 151.219C160.781 162.77 159.03 178.871 159.847 196.489V196.606C159.847 197.539 159.964 198.59 159.964 199.523C159.964 199.523 149.113 204.073 141.529 201.857C141.529 201.857 135.578 170.004 141.179 153.902C141.296 153.786 141.529 153.436 141.879 152.969C141.996 152.852 142.112 152.619 142.229 152.502C145.379 147.952 154.713 133.601 156.58 119.949C156.58 119.949 165.331 97.4307 182.249 94.1638C184.466 93.6971 186.916 93.6971 189.483 94.0471C189.366 93.9304 191.583 105.131 186.799 117.849Z",
    fill: "#097A57"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M138.956 376.629C137.323 388.063 123.322 389.463 123.322 389.463L118.304 389.23L116.088 391.797C110.604 394.947 100.803 392.38 100.803 392.38L100.336 389.347C100.336 389.347 99.5195 387.48 99.7529 386.08C99.8695 384.68 101.853 369.978 101.853 369.978C101.853 369.978 108.97 369.862 111.304 367.995C111.771 367.528 113.987 371.378 114.337 370.795C115.504 368.928 113.987 362.278 113.987 362.278C113.987 362.278 120.288 369.978 124.372 373.129C124.138 373.012 119.238 370.678 118.188 371.028C117.371 371.262 119.821 376.512 123.205 380.012C124.138 381.063 125.188 381.996 126.355 382.579C131.022 385.03 137.673 381.413 138.956 376.629Z",
    fill: "#2D5912"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M225.185 296.948C225.185 296.948 225.069 297.182 224.835 297.648C219.935 308.149 204.3 307.566 204.3 307.566L200.333 307.216C199.983 307.799 199.633 308.266 199.633 308.266C194.616 310.249 185.282 308.266 185.282 308.266L184.348 304.766C183.298 298.348 187.732 285.397 187.732 285.397C187.732 285.397 193.216 283.88 195.433 284.697C197.65 285.514 198.816 288.897 199.983 288.897C200.917 288.897 201.267 283.764 201.267 283.764C201.267 283.764 204.3 288.197 207.45 290.998C207.1 290.998 203.717 290.764 201.85 292.864C201.033 293.798 202.783 296.248 205.467 298.582C208.734 301.265 213.518 303.715 216.668 303.015C222.618 301.849 225.069 297.182 225.185 296.948Z",
    fill: "#2D5912"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M208.961 296.938C208.961 296.938 212.461 299.389 216.428 299.622C220.395 299.855 222.145 296.472 222.145 296.472C222.145 296.472 217.828 298.922 208.961 296.938Z",
    fill: "url(#paint42_linear_841_877)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.318 135.584C181.318 135.584 181.201 135.817 181.085 136.167C179.451 140.134 175.718 147.018 175.134 150.752C175.134 150.752 168.367 164.053 154.249 166.387L149.115 159.969L156.699 147.952C156.699 147.952 170.117 145.968 176.418 140.134C176.418 140.134 179.218 136.051 180.851 132.9C180.851 133.017 181.435 134.067 181.318 135.584Z",
    fill: "#73BF43"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M181.082 136.167C179.448 140.134 175.714 147.018 175.131 150.752C175.131 150.752 163.113 156.586 162.763 155.536C162.413 154.369 168.13 149.002 174.081 144.335C178.631 140.718 180.498 137.451 181.082 136.167Z",
    fill: "url(#paint43_linear_841_877)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.927 116.916C121.927 116.916 122.86 136.051 126.827 144.335C130.678 152.619 122.394 167.203 122.394 167.203C122.394 167.203 124.027 158.336 124.144 152.036C124.261 145.852 120.877 128.467 121.927 116.916Z",
    fill: "#097A57"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.714 320.75L538.697 360.653C538.697 360.653 500.427 362.287 443.139 363.454C358.198 365.204 231.72 366.137 126.595 359.72C122.044 359.487 117.61 359.137 113.293 358.903C103.959 358.32 94.9752 357.62 86.1077 356.803C67.5561 355.17 49.9379 353.303 33.9532 351.086L29.0527 312.816H29.1694H29.5194H29.7528C29.8695 312.816 30.1028 312.816 30.3362 312.816H30.6862C34.3032 313.166 44.4541 313.983 60.0888 315.033L61.8389 315.149C72.3398 315.85 85.291 316.666 100.342 317.6C106.76 317.95 113.643 318.3 120.877 318.766C196.834 322.733 314.911 326.584 455.507 323.55C484.092 322.85 513.495 322.033 543.714 320.75Z",
    fill: "#437B1F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M246.07 353.07L248.287 348.052C250.271 349.219 252.838 349.919 255.054 349.919C257.038 349.919 257.738 349.453 257.738 348.752C257.738 346.186 246.42 348.286 246.42 340.585C246.42 336.735 249.571 333.701 255.988 333.701C258.788 333.701 261.588 334.285 263.689 335.451L261.588 340.468C259.605 339.418 257.621 338.952 255.871 338.952C253.888 338.952 253.188 339.535 253.188 340.235C253.188 342.685 264.505 340.702 264.505 348.169C264.505 351.903 261.355 355.053 254.938 355.053C251.554 355.17 248.17 354.353 246.07 353.07Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M270.689 339.652H264.738V334.285H283.64V339.652H277.689V354.82H270.805V339.652H270.689Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M298.341 351.203H290.524L289.124 354.82H282.123L291.107 334.401H297.874L306.859 354.82H299.741L298.341 351.203ZM296.474 346.185L294.491 341.052L292.507 346.185H296.474Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M316.776 349.569H314.909V354.703H308.025V334.285H317.826C323.543 334.285 327.16 337.318 327.16 341.985C327.16 344.902 325.76 347.119 323.31 348.403L327.627 354.703H320.276L316.776 349.569ZM317.36 339.535H314.793V344.319H317.36C319.226 344.319 320.16 343.385 320.16 341.869C320.16 340.469 319.226 339.535 317.36 339.535Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M333.927 339.652H327.977V334.285H346.878V339.652H340.928V354.82H334.044V339.652H333.927Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1077 356.687C67.5561 355.053 49.9379 353.186 33.9532 350.969L29.0527 312.699H29.1694H29.5194L61.8389 315.15L86.1077 356.687Z",
    fill: "#AD8EA9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.596 359.604C122.046 359.37 117.612 359.02 113.295 358.787L100.344 317.6C106.761 317.95 113.645 318.3 120.879 318.767L126.596 359.604Z",
    fill: "#AD8EA9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.714 320.75L538.697 360.653C538.697 360.653 500.427 362.287 443.139 363.454L455.506 323.55C484.092 322.85 513.495 322.033 543.714 320.75Z",
    fill: "#AD8EA9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M521.195 266.145L507.66 231.492L508.477 231.609L464.373 277.58L464.023 277.93L463.673 277.463L442.788 237.559H443.488L435.087 251.561L434.854 251.911L434.62 251.677L377.099 213.291L376.865 213.174L377.099 212.941L418.402 155.302H418.519L458.422 118.782H458.539L447.921 116.916L458.539 118.782L418.636 155.419L377.449 213.174L377.332 212.941L434.97 251.094L434.504 251.211L442.788 237.209L443.138 236.626L443.488 237.209L464.49 277.113L463.789 276.996L507.777 230.909L508.36 230.325L508.593 231.142L522.245 265.679L521.195 266.145Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M521.663 301.965C533.391 301.965 542.898 292.458 542.898 280.73C542.898 269.002 533.391 259.495 521.663 259.495C509.935 259.495 500.428 269.002 500.428 280.73C500.428 292.458 509.935 301.965 521.663 301.965Z",
    fill: "#73BF43"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M508.128 244.793C515.603 244.793 521.663 238.734 521.663 231.259C521.663 223.784 515.603 217.724 508.128 217.724C500.653 217.724 494.594 223.784 494.594 231.259C494.594 238.734 500.653 244.793 508.128 244.793Z",
    fill: "#73BF43"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M463.906 287.614C469.641 287.614 474.29 282.965 474.29 277.23C474.29 271.495 469.641 266.845 463.906 266.845C458.171 266.845 453.521 271.495 453.521 277.23C453.521 282.965 458.171 287.614 463.906 287.614Z",
    fill: "#73BF43"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M443.137 246.777C448.034 246.777 452.004 242.807 452.004 237.91C452.004 233.012 448.034 229.042 443.137 229.042C438.24 229.042 434.27 233.012 434.27 237.91C434.27 242.807 438.24 246.777 443.137 246.777Z",
    fill: "#437B1F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.738 251.794C441.738 255.644 438.587 258.795 434.737 258.795C430.887 258.795 427.736 255.644 427.736 251.794C427.736 247.944 430.887 244.793 434.737 244.793C438.587 244.793 441.738 247.944 441.738 251.794Z",
    fill: "#437B1F"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.05 213.057C383.05 216.208 380.484 218.891 377.217 218.891C374.066 218.891 371.383 216.324 371.383 213.057C371.383 209.79 373.95 207.223 377.217 207.223C380.367 207.34 383.05 209.907 383.05 213.057Z",
    fill: "#437B1F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.641 118.782C460.641 119.949 459.707 120.999 458.424 120.999C457.257 120.999 456.207 120.066 456.207 118.782C456.207 117.616 457.14 116.565 458.424 116.565C459.707 116.565 460.641 117.616 460.641 118.782Z",
    fill: "#437B1F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.837 155.302C422.837 157.752 420.854 159.619 418.52 159.619C416.07 159.619 414.203 157.636 414.203 155.302C414.203 152.852 416.187 150.985 418.52 150.985C420.97 150.985 422.837 152.969 422.837 155.302Z",
    fill: "#437B1F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M523.53 274.196V286.214H519.446V277.23H517.346V274.196H523.53Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M511.862 232.309V234.526H504.861V232.776L508.011 229.859C508.595 229.276 508.712 228.926 508.712 228.692C508.712 228.226 508.478 227.992 507.895 227.992C507.428 227.992 506.845 228.226 506.611 228.809L504.395 227.759C504.978 226.592 506.261 225.775 508.128 225.775C510.228 225.775 511.629 226.825 511.629 228.459C511.629 229.276 511.395 230.092 510.112 231.259L508.828 232.426H511.862V232.309Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M466.825 278.397C466.825 279.563 465.892 280.847 463.558 280.847C462.625 280.847 461.575 280.613 460.758 280.263L461.575 278.513C462.158 278.863 462.858 278.98 463.441 278.98C464.025 278.98 464.375 278.747 464.375 278.397C464.375 278.047 464.141 277.93 463.558 277.93H462.625V276.413L463.675 275.363H461.108V273.613H466.358V275.13L465.075 276.413C466.242 276.646 466.825 277.463 466.825 278.397Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M445.122 239.66H444.422V240.593H442.672V239.66H439.988V238.493L442.205 235.226H444.072L442.088 238.259H442.789V237.443H444.422V238.259H445.122V239.66Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M436.953 252.611C436.953 253.427 436.253 254.244 434.853 254.244C434.153 254.244 433.453 254.128 432.986 253.777L433.57 252.611C433.92 252.844 434.386 252.961 434.853 252.961C435.203 252.961 435.437 252.844 435.437 252.611C435.437 252.377 435.32 252.261 434.736 252.261H433.336L433.57 249.344H436.72V250.511H434.853V250.977H435.086C436.37 251.094 436.953 251.794 436.953 252.611Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M378.732 213.874C378.732 214.691 378.032 215.274 377.099 215.274C375.932 215.274 375.115 214.574 375.115 213.291C375.115 211.891 376.049 211.074 377.332 211.074C377.799 211.074 378.266 211.191 378.616 211.424L378.149 212.357C377.915 212.241 377.682 212.124 377.449 212.124C376.982 212.124 376.632 212.357 376.515 212.824C376.749 212.707 376.982 212.591 377.332 212.591C378.149 212.591 378.732 213.057 378.732 213.874ZM377.449 213.874C377.449 213.641 377.332 213.408 376.982 213.408C376.749 213.408 376.515 213.524 376.515 213.874C376.515 214.108 376.632 214.341 376.982 214.341C377.332 214.341 377.449 214.108 377.449 213.874Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_841_877",
    x1: 451.704,
    y1: 153.384,
    x2: 451.121,
    y2: 153.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#8C74B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD8E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_841_877",
    x1: 451.705,
    y1: 259.501,
    x2: 451.121,
    y2: 259.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#8268AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A1CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_841_877",
    x1: -19.6336,
    y1: 418.022,
    x2: -19.0502,
    y2: 418.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_841_877",
    x1: 451.704,
    y1: 380.692,
    x2: 451.121,
    y2: 380.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#D8CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_841_877",
    x1: -19.6318,
    y1: 357.645,
    x2: -19.0484,
    y2: 357.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_841_877",
    x1: 451.706,
    y1: 337.133,
    x2: 451.122,
    y2: 337.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#D8CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_841_877",
    x1: -19.6337,
    y1: 321.779,
    x2: -19.0503,
    y2: 321.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_841_877",
    x1: 451.704,
    y1: 310.92,
    x2: 451.12,
    y2: 310.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#D8CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_841_877",
    x1: -19.6348,
    y1: 300.912,
    x2: -19.0514,
    y2: 300.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_841_877",
    x1: -19.634,
    y1: 285.481,
    x2: -19.0506,
    y2: 285.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_841_877",
    x1: 451.704,
    y1: 279.47,
    x2: 451.12,
    y2: 279.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#D8CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_841_877",
    x1: 451.703,
    y1: 273.331,
    x2: 451.12,
    y2: 273.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_841_877",
    x1: 451.703,
    y1: 264.3,
    x2: 451.12,
    y2: 264.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_841_877",
    x1: 451.705,
    y1: 255.023,
    x2: 451.122,
    y2: 255.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_841_877",
    x1: 451.705,
    y1: 248.196,
    x2: 451.122,
    y2: 248.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_841_877",
    x1: 451.705,
    y1: 240.406,
    x2: 451.121,
    y2: 240.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_841_877",
    x1: 451.705,
    y1: 233.396,
    x2: 451.122,
    y2: 233.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_841_877",
    x1: 451.703,
    y1: 267.31,
    x2: 451.12,
    y2: 267.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#D8CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_841_877",
    x1: 451.704,
    y1: 144.477,
    x2: 451.12,
    y2: 144.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_841_877",
    x1: 451.702,
    y1: 227.555,
    x2: 451.119,
    y2: 227.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#B7A9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_841_877",
    x1: 451.703,
    y1: 292.025,
    x2: 451.119,
    y2: 292.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#D8CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_841_877",
    x1: -19.6349,
    y1: 273.286,
    x2: -19.0516,
    y2: 273.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159875,
    stopColor: "#D1A1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#BD89C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_841_877",
    x1: -19.6328,
    y1: 152.294,
    x2: -19.0494,
    y2: 152.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF9F7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB06D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_841_877",
    x1: -19.6326,
    y1: 146.372,
    x2: -19.0492,
    y2: 146.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159875,
    stopColor: "#D1A1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#BD89C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_841_877",
    x1: -19.6334,
    y1: 148.852,
    x2: -19.05,
    y2: 148.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159875,
    stopColor: "#D1A1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#BD89C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_841_877",
    x1: -19.4601,
    y1: 171.83,
    x2: -18.8781,
    y2: 171.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E1DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1737,
    stopColor: "#E7E2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5619,
    stopColor: "#F0ECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_841_877",
    x1: -19.6398,
    y1: 303.059,
    x2: -19.0564,
    y2: 303.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#FF6B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_841_877",
    x1: -19.6397,
    y1: 384.974,
    x2: -19.0563,
    y2: 384.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#FF6B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_841_877",
    x1: -19.6334,
    y1: 69.9592,
    x2: -19.0501,
    y2: 69.9592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF9F7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB06D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_841_877",
    x1: -19.6327,
    y1: 61.461,
    x2: -19.0493,
    y2: 61.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#721D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A63624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_841_877",
    x1: -19.6347,
    y1: 63.656,
    x2: -19.0513,
    y2: 63.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#AE3438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#E06E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_841_877",
    x1: -19.633,
    y1: 58.7786,
    x2: -19.0496,
    y2: 58.7786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#AE3438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#E06E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_841_877",
    x1: -19.6336,
    y1: 48.7337,
    x2: -19.0502,
    y2: 48.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#AE3438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#E06E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_841_877",
    x1: -19.632,
    y1: 42.5867,
    x2: -19.0486,
    y2: 42.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#AE3438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#E06E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_841_877",
    x1: -19.6338,
    y1: 52.847,
    x2: -19.0505,
    y2: 52.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#AE3438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#B54F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_841_877",
    x1: -19.6331,
    y1: 50.4423,
    x2: -19.0497,
    y2: 50.4423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#E06E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    stopColor: "#AE3438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_841_877",
    x1: -19.6355,
    y1: 145.83,
    x2: -19.0521,
    y2: 145.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#B060F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_841_877",
    x1: -19.8494,
    y1: 263.369,
    x2: -19.2672,
    y2: 263.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00595246,
    stopColor: "#570E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_841_877",
    x1: -21.4637,
    y1: 238.807,
    x2: -20.8815,
    y2: 238.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D4009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#CC5A33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_841_877",
    x1: -19.637,
    y1: 131.592,
    x2: -19.0536,
    y2: 131.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159875,
    stopColor: "#D1A1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#BD89C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_841_877",
    x1: -19.6351,
    y1: 210.853,
    x2: -19.0517,
    y2: 210.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4867C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#FF9F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_841_877",
    x1: -19.6337,
    y1: 201.691,
    x2: -19.0503,
    y2: 201.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E1DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1737,
    stopColor: "#E7E2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5619,
    stopColor: "#F0ECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_841_877",
    x1: -19.6413,
    y1: 298.078,
    x2: -19.0579,
    y2: 298.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08447,
    stopColor: "#081A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#1F676B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5735,
    stopColor: "#32A3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7663,
    stopColor: "#3FCFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9144,
    stopColor: "#47EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_841_877",
    x1: -19.6342,
    y1: 145.875,
    x2: -19.0509,
    y2: 145.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08447,
    stopColor: "#081A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#1F676B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5735,
    stopColor: "#32A3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7663,
    stopColor: "#3FCFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9144,
    stopColor: "#47EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AF4FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.012105a878fdc787c5bf8ebd396e53e9.svg";
export { ForwardRef as ReactComponent };